import React, { useEffect, useRef, useState } from 'react';
import { TreatmentType } from '../models/superbit-api-models';
import { Select, TimePicker  } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import './_TaskAddTask.css';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { SimulatorModel } from '../models/SimulatorModel';
import { WhatsAppModel } from '../models/WhatsAppModel';
// import 'antd/dist/antd.css';

type Props = {
    ShowHidePopup: Function;
    ClosePopup?: Function;
    OnApprove?: Function;
    type: number;
    messageTitle?: string;
};

const TasksSendWhatsAppPopup = (props: Props) => {
    const editorRef = useRef<TinyMCEEditor | null>(null);
    const CreatedDateRef = React.createRef<DatePicker>();
    const ReminderDateRef = React.createRef<DatePicker>();
    const CustomerBirthDateRef = React.createRef<DatePicker>();
    const IdentityIssueDateRef = React.createRef<DatePicker>();
    const DriverLicensIssueDateRef = React.createRef<DatePicker>();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const whatsAppModel: WhatsAppModel = new WhatsAppModel();

    const [timeFormat, setTimeFormat] = useState<string>('HH:mm');
    const [eventDate, setEventDate] = useState<Date | null>(null);
    const [popUpType, setPopUpType] = useState<TreatmentType>(TreatmentType._0);
    const [showPrintBtn, setShowPrintBtn] = useState<boolean>(false);
    const [popupTitles, setpopupTitles] = useState<any[]>([
        'תיעוד שיחה',
        'משימה',
        'סמס',
        'תיעוד דוא"ל',
        'פקס',
        'פְּגִישָׁה',
        'סיכום פגישה',
        'דואר יוצא',
        'תיעוד',
        'מכתב',
        'וואצפ',
    ]);
    const [aditionalActionList, setAdditionalActionList] = useState<any[]>([
        {
            date: '14/08/2024 12:12',
            owner: 'ברוריה אקסול',
            label: 'עדכון יעד סיום',
            description: 'עדכון יעד סיום'
        },
        {
            date: '14/08/2024 12:22',
            owner: 'ברוריה אקסול',
            label: 'עדכון יעד סיום',
            description: 'עדכון יעד סיום'
        },
        {
            date: '14/08/2024 12:32',
            owner: 'ברוריה אקסול',
            label: 'עדכון יעד סיום',
            description: 'עדכון יעד סיום'
        },
        {
            date: '14/08/2024 12:42',
            owner: 'ברוריה אקסול',
            label: 'עדכון יעד סיום 3',
            description: 'עדכון יעד סיום'
        },
        {
            date: '14/08/2024 12:52',
            owner: 'ברוריה אקסול',
            label: 'עדכון יעד סיום 4',
            description: 'עדכון יעד סיום'
        }
    ]);
    const [showNewAction, setShowNewAction] = useState<boolean>(false);
    const [newAction, setNewAction] = useState<any>({
        date: null,
        owner: '',
        label: '',
        description: ''
    });
    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [selectedAgent, setSelectedAgent] = useState<any | null>(null)
    const [inssuranceCompanyListList, setInssuranceCompanyListList] = useState<any[]>([])
    const [selectedCompany, setSelectedCompany] = useState<any | null>(null)
    const [usersList, setUsersList] = useState<any[]>([]);
    const [selectedUser, setSelectedUser] = useState<any | null>(null)
    const [customerssList, setCustomersList] = useState<any[]>([]);
    const [selectedCustomer, setSelectedCustomer] = useState<any | null>(null)

    const closePopup = (status?: string)=>{
        if (props.ClosePopup) {
            props.ClosePopup(status);  
         }
    }

    const approve = () => {
        if (props.OnApprove) {
            props.OnApprove();
        }
    }

    const onEventDateChange = (newDate: Date) =>{
        setEventDate(newDate);
    }

    const onClearNewAction = () => {
        setNewAction({
            date: null,
            owner: '',
            label: '',
            description: ''
        });
        setShowNewAction(false)
    }

    const onSaveNewAction = async () => {
        const currentActionsList = aditionalActionList;
        const action = newAction;
        console.log('onSaveNewAction', currentActionsList);
        currentActionsList.push(action);
        setNewAction({
            date: null,
            owner: '',
            label: '',
            description: ''
        });
        await setAdditionalActionList(currentActionsList);
        setShowNewAction(false)
        console.log('onSaveNewAction', currentActionsList);
    }
    const onDeleteAction = async (i: number) => {
        const currentActionsList = aditionalActionList;
        await setAdditionalActionList([]);
        currentActionsList.splice(i, 1);
        await setAdditionalActionList(currentActionsList);
        setShowNewAction(false)
        console.log('onDeleteAction', currentActionsList);
    }
    const onNewActionParameterChange = (name: string, value: string | Date) => {
        const action = newAction;
        action[name] = moment(value).format('DD-MM-YYYY HH:mm');
        setNewAction(action);
        console.log('onNewActionParameterChange', name, value, newAction)
    }
    const onNewActionParameterChange2 = async (name: string, event: any) => {
        const newValue = event.target.value;
        const action = newAction;
        action[name] = newValue;
        await setNewAction(action);
        console.log('onNewActionParameterChange', name, newValue, newAction)
    }

    const getComboData = async () => {
        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name
            })
        })
        setInssuranceCompanyListList(fixedInsuranceCompanies);
        const agentsData = await simulatorModel.getCustomerCardAgents();
        setAgentsList(agentsData.map((a: any)=>{
            return {
                value: a.id,
                label: a.name
            }
        }))
        const users = await whatsAppModel.customerCardGetUsers();
        setUsersList(users.map((u: any, i: number)=>{
            return {
                value: u.id,
                label: u.fullName
            }
        }))
        const customers = await simulatorModel.customerGetAll()
        setCustomersList(customers.map((u:any, i: number)=>{
            return{
                value: u.id,
                label: u.fullName
            }
        }))
        console.log('getComboData agents', agentsData, agentsList, users, customers);

    }

    const onSelectAgent = (e: any) => {
        const agentName = e.target.value;
        const selected = agentsList.find((a: any)=> a.label == agentName);
        if(selected) {
          setSelectedAgent(selected)
        } else {
            setSelectedAgent({
                label: agentName,
                value: null
            })
        }
    }
    const onSelectUser = (e: any) => {
        const userName = e.target.value;
        const selected = usersList.find((a: any)=> a.label == userName);
        if(selected) {
          setSelectedUser(selected)
        } else {
            setSelectedUser({
                label: userName,
                value: null
            })
        }
    }
    const onSelectInsuranceCompany = (e: any) => {
        const companyName = e.target.value;
        const selected = agentsList.find((a: any)=> a.label == companyName);
        // this.setState({selectedSaleManName: search});
        // const selected = this.state.salesPeopleList.find((sp: any)=> sp.label == search);
        if(selected) {
            setSelectedCompany(selected)
        } else {
            setSelectedCompany({
                label: companyName,
                value: null
            })
        }
    }
    const onSelectCustomer = (e: any) => {
        const customerName = e.target.value;
        const selected = agentsList.find((a: any)=> a.label == customerName);
        // this.setState({selectedSaleManName: search});
        // const selected = this.state.salesPeopleList.find((sp: any)=> sp.label == search);
        if(selected) {
            setSelectedCustomer(selected)
        } else {
            setSelectedCustomer({
                label: customerName,
                value: null
            })
        }
    }

    const emptyFunc = () => {}

    useEffect(()=>{
        console.log('TasksSendWhatsAppPopup', props)
        getComboData();
        setPopUpType(props.type);
        switch (props.type) {
            case TreatmentType._0:
                setShowPrintBtn(true)
                break;
            case TreatmentType._4:
                setShowPrintBtn(true)
                break;
        
            default:
                break;
        }
        ;
    },[])

    // useEffect(()=>{
    //     console.log('getComboData inssuranceCompanyListList', inssuranceCompanyListList);
    // },[inssuranceCompanyListList])
    
        return ( <>
            <div className={`popup-wrapper add-treatment-popup add-task-popup ${props.type}`}>
                <section className="popup-window rtl">
                    <div className="close-icon pointer" onClick={(e:any)=>closePopup()}></div>
                    <div className="popup-content">
                        <div className="popup-header">
                            <div className="popup-title">
                                שלח וואצפ
                            </div>
                        </div>
                        <div className="popup-body">
                            <div className="parameter-row single-item">
                                <div className={`parameter-item`}>
                                    <div className="field">
                                        <div className="value">
                                            אל:
                                            <input type='text' />
                                        </div>
                                        <div className='error-message'>
                                            {/* *{this.state.errors.requiredField} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className='parameter-row single-item'>
                                <div className={`parameter-item`}>
                                    <div>
                                            <Editor
                                                onInit={(evt, editor) => editorRef.current = editor}
                                                apiKey='djtel3sjck5h6t7794w5lrm3q570rvj1rxr48es3xq7ft83w'
                                                initialValue={''}
                                                init={{
                                                    height: 250,
                                                    width: 750,
                                                    menubar: false,
                                                    plugins: [
                                                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                    ],
                                                    language: "he_IL",
                                                    toolbar: 'undo redo | blocks | ' +
                                                        'bold italic forecolor | alignleft aligncenter ' +
                                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                                        'removeformat | help',
                                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                                }}
                                                onChange={emptyFunc}
                                            />
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="popup-footer">
                            <button className="button blue pointer"  onClick={(e:any)=>emptyFunc()}>
                                שמור
                            </button>
                            <button className={`button white blue-border pointer ${showPrintBtn ? '' : 'hide'}`} disabled onClick={(e:any)=>emptyFunc()}>
                                הדפס
                            </button>
                            <button className="button white blue-border pointer"  onClick={(e:any)=>closePopup()}>
                                ביטול
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </>  
            
        );
    // }
  }
  export default TasksSendWhatsAppPopup;